<template>
  <app-chip class="bg-deco-100 text-deco-950" icon="ph:map-pin" :size="size">
    <slot>
      {{ address[field] }}
    </slot>
  </app-chip>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    size?: "small";
    address: DatabaseCompositeType<"address">;
    field?: keyof DatabaseCompositeType<"address">;
  }>(),
  { size: undefined, field: "label" },
);
</script>
